import React, { useEffect, useState } from "react";

import EditInvoice from "./EditInvoice";
import InvoiceDetails from "./InvoiceDetails";
import { useSearchParams } from "react-router-dom";

const InvoiceView = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const isEdit = searchParams.get("isEdit");

  const [view, setView] = useState<"details" | "edit">(
    isEdit ? "edit" : "details",
  );

  useEffect(() => {
    if (isEdit) {
      setView("edit");
    }
  }, [isEdit]);

  switch (view) {
    case "details":
      return <InvoiceDetails setView={setView} />;
    case "edit":
      return <EditInvoice setView={setView} />;
  }
};

export default InvoiceView;
